import React from 'react'
import telegram_gif from '../../assets/images/telegram_gif.gif'
import telegram_offical_gif from '../../assets/images/telegram_offical_gif.gif'
import spining_gif from '../../assets/images/spining_gif.gif'
const SingleCustomerComment = ({ data }) => {
    return (
        <>
            <div className="bg-[#222] font-bold text-sm p-2.5 border-t-0 border border-[#444] lg:hidden"> 댓글 </div>
            <table cellpadding="3" cellspacing="0" width="100%" className="text-[9.6px] lg:text-xs text-white font-sans-serif lg:font-Time bg-[#222] lg:bg-transparent relative p-2.5 lg:p-0 border lg:border-0 border-[#444]">
                <tbody>
                    <tr>
                        <td colspan="2" className='lg:bg-[#333] text-white px-2.5 pb-0 lg:pb-2 pt-2 lg:border-b border-b-[#444]'>
                            <strong className='text-white lg:text-[#C4A43F] '>
                                <img src={spining_gif} alt="" className='w-[15px] mr-1 inline-block lg:hidden' />
                                {data?.replied_by.username} </strong>
                            <small className="ml-2.5 lg:hidden"> {new Date(data?.replied_at).toLocaleDateString('ko-KR')}</small>
                        </td>
                    </tr>
                    <tr>
                        <td align="left" className="lg:bg-[#333] text-white px-2.5 pt-0 lg:pt-2 pb-2 border-b  border-b-[#444]" >
                            <div>
                                {data?.reply_content}
                            </div>
                            {/* 안녕하세요 나루토카지노 운영팀 입니다!
                            <br />
                            <br />
                            - 신속한 상담을 위해 정확한 문의내용 남겨주시면 감사하겠습니다 회원님^^
                            <br />
                            <br />이해가 되지 않거나 불편하신 사항이 있으시면 텔레그램으로 문의 주세요
                            <br />
                            <br />나루토카지노 텔레그램 고객센터 안내 (※사칭 및 유사 아이디 주의 부탁드립니다※)
                            <br />클릭 시 자동연결
                            <a href="#" target="_blank">
                                <strong className='text-[#0000FF]'>@NRT114</strong>
                            </a> 나루토카지노 고객센터[해당계정 외 전부사칭]
                            <br />클릭 시 자동연결
                            <a href="#" target="_blank"><strong className='text-[#0000FF]'>@나루토카지노</strong></a> 나루토카지노 평생도메인
                            <br />
                            <br />아이디 뒤에 아무런 문자가 붙지 않습니다.
                            <br />뒤에 다른 문자가 붙어 있는 아이디는 사칭 입니다.
                            <br />고객센터에서 만약 다른 놀이터로 가입을 권유한다면 사칭 입니다.
                            <br />사칭 및 유사 아이디 주의 부탁드립니다.
                            <br />
                            */}
                            <a href="#" target="_blank" className='inline-block'><img src={telegram_gif} /></a>
                            <a href="#" target="_blank" className='inline-block'><img src={telegram_offical_gif} /></a>
                            <br />&nbsp;
                        </td>
                        <td width="100" align="center" className="hidden lg:table-cell bg-[#333] text-white px-2.5 py-2 border-b  border-b-[#444]" >{new Date(data?.replied_at).toLocaleDateString('ko-KR')}</td>
                    </tr>
                    <tr>
                        <td align="left" className="lg:hidden lg:bg-[#333] text-white py-2.5 border-b  border-b-[#444]" ></td>
                    </tr>
                </tbody>
            </table>
        </>
    )
}
export default SingleCustomerComment